/**
 * Access Control Configuration for Organizations (Client)
 * Must match the server-side configuration
 */

import { createAccessControl } from "better-auth/plugins/access";

// Define all possible permissions for each resource
const statement = {
	organization: ["update", "delete"],
	member: ["create", "read", "update", "delete"],
	invitation: ["create", "read", "cancel"],
	project: ["create", "read", "update", "delete"],
} as const;

// Create the access control instance
export const ac = createAccessControl(statement);

// Define roles with their permissions
const owner = ac.newRole({
	organization: ["update", "delete"],
	member: ["create", "read", "update", "delete"],
	invitation: ["create", "read", "cancel"],
	project: ["create", "read", "update", "delete"],
});

// "admin" and "manager" were merged into one role, "manager", on 27 Oct 2026.
// It keeps the former admin rights; the API's ROLE_PERMISSIONS is the source of truth.
const manager = ac.newRole({
	organization: ["update"],
	member: ["create", "read", "update", "delete"],
	invitation: ["create", "read", "cancel"],
	project: ["create", "read", "update", "delete"],
});

const member = ac.newRole({
	member: ["read"],
	invitation: ["read"],
	project: ["create", "read", "update"],
});

const viewer = ac.newRole({
	member: ["read"],
	project: ["read"],
});

export const roles = { owner, manager, member, viewer };
